module.exports = __webpack_public_path__ + "img/02-lock-icon-purple.d0801412.svg";